var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTab1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23753 4.47003H17.9293C17.4586 2.88742 16.713 1.37063 15.6918 0H0C1.02124 1.37063 1.76677 2.88742 2.23753 4.47003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82346 11.6871L8.06915 11.6804C9.55647 11.6397 10.9809 11.0541 12.0894 10.029C13.1969 11.0541 14.6223 11.6397 16.1096 11.6804L16.3553 11.6871L16.194 13.3482H19.525C20.3409 10.9747 20.5237 8.42706 20.0727 5.97522H2.59911C3.19085 9.19368 2.69101 12.5796 1.09961 15.5154H8.19482L7.82439 11.6871H7.82346Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0257 15.0701L15.9685 15.6606C15.9151 16.2084 15.7838 16.7389 15.5831 17.2374C15.2399 18.0882 14.6941 18.8461 13.9842 19.4337L12.088 21.0017L10.1918 19.4337C9.48191 18.8461 8.93613 18.0882 8.5929 17.2374H0.0253906L4.46013 23.9995H18.7556V23.9753L23.9996 15.0701H16.0257Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2359H0.0253L0.0131185 17.2181C0.00843332 17.2237 0.00468518 17.2303 0 17.2359Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1986L0.0131185 17.2183C0.0178037 17.2118 0.0224889 17.2052 0.0281111 17.1986H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab1);
export default __webpack_public_path__ + "static/media/tab1.5389dd1e555ad5447c26f86f5ecb2014.svg";
export { ForwardRef as ReactComponent };